"use client";

import { createContext, useContext, useState, ReactNode } from "react";
import type { ChatRefContent } from "../Sender/type";

interface HomePageSenderContextValue {
  chatRefContent: ChatRefContent | null;
  setChatRefContent: (content: ChatRefContent | null) => void;
}

const HomePageSenderContext = createContext<HomePageSenderContextValue | null>(
  null,
);

interface HomePageSenderProviderProps {
  children: ReactNode;
}

export const HomePageSenderProvider = ({
  children,
}: HomePageSenderProviderProps) => {
  const [chatRefContent, setChatRefContent] = useState<ChatRefContent | null>(
    null,
  );

  return (
    <HomePageSenderContext.Provider
      value={{
        chatRefContent,
        setChatRefContent,
      }}
    >
      {children}
    </HomePageSenderContext.Provider>
  );
};

export const useHomePageSenderContext = () => {
  const context = useContext(HomePageSenderContext);
  if (!context) {
    throw new Error(
      "useHomePageSenderContext must be used within HomePageSenderProvider",
    );
  }
  return context;
};
